<app-manage-shipments-component [isFromLclContainersManagement] = "true"></app-manage-shipments-component>
